import { PhotoMetadata } from "./components/gallery";

const vertical = "5/6";
const horizontal = "3/2";

export const afpMissUniversePhotosMetadata: PhotoMetadata[] = [
  { aspectRatio: horizontal },
  { aspectRatio: horizontal },
  { aspectRatio: horizontal },
];

export const afpFemiKutiPhotosMetadata: PhotoMetadata[] = [
  { aspectRatio: horizontal },
  { aspectRatio: horizontal },
];

export const afpAfconPhotosMetadata: PhotoMetadata[] = [
  { aspectRatio: horizontal },
  { aspectRatio: horizontal },
  { aspectRatio: horizontal },
];

export const afpFuelScarcityPhotosMetadata: PhotoMetadata[] = [
  { aspectRatio: horizontal },
  { aspectRatio: horizontal },
  { aspectRatio: horizontal },
];

export const afpCostOfLivingPhotosMetadata: PhotoMetadata[] = [
  { aspectRatio: horizontal },
  { aspectRatio: horizontal },
  { aspectRatio: horizontal },
];

export const afpPhotosMetadata: PhotoMetadata[] = [
  { aspectRatio: horizontal },
  { aspectRatio: horizontal },
  { aspectRatio: horizontal },
  { aspectRatio: horizontal },
  { aspectRatio: horizontal },
];

export const mampPhotosMetadata: PhotoMetadata[] = [
  { aspectRatio: horizontal },
  { aspectRatio: horizontal },
  { aspectRatio: horizontal },
  { aspectRatio: horizontal },
  { aspectRatio: horizontal },
  { aspectRatio: horizontal },
  { aspectRatio: horizontal },
  { aspectRatio: horizontal },
  { aspectRatio: horizontal },
  { aspectRatio: horizontal },
];

export const attestationPhotosMetadata: PhotoMetadata[] = [
  { aspectRatio: horizontal },
  { aspectRatio: horizontal },
  { aspectRatio: horizontal },
  { aspectRatio: horizontal },
  { aspectRatio: horizontal },
  { aspectRatio: horizontal },
  { aspectRatio: horizontal },
  { aspectRatio: horizontal },
  { aspectRatio: horizontal },
  { aspectRatio: horizontal },
  { aspectRatio: horizontal },
  { aspectRatio: horizontal },
  { aspectRatio: horizontal },
  { aspectRatio: horizontal },
  { aspectRatio: horizontal },
];

export const yoursinarmsPhotosMetadata: PhotoMetadata[] = [
  { aspectRatio: horizontal },
  { aspectRatio: horizontal },
  { aspectRatio: horizontal },
  { aspectRatio: horizontal },
  { aspectRatio: horizontal },
  { aspectRatio: horizontal },
  { aspectRatio: horizontal },
  { aspectRatio: horizontal },
  { aspectRatio: horizontal },
  { aspectRatio: horizontal },
  { aspectRatio: horizontal },
  { aspectRatio: horizontal },
  { aspectRatio: horizontal },
  { aspectRatio: horizontal },
];

export const resalePhotosMetadata: PhotoMetadata[] = [
  { aspectRatio: horizontal },
  { aspectRatio: horizontal },
  { aspectRatio: horizontal },
  { aspectRatio: horizontal },
  { aspectRatio: horizontal },
  { aspectRatio: horizontal },
  { aspectRatio: horizontal },
  { aspectRatio: horizontal },
  { aspectRatio: horizontal },
  { aspectRatio: horizontal },
  { aspectRatio: horizontal },
];

export const ottodailyPhotosMetadata: PhotoMetadata[] = [
  { aspectRatio: horizontal },
  { aspectRatio: horizontal },
  { aspectRatio: horizontal },
  { aspectRatio: horizontal },
  { aspectRatio: horizontal },
  { aspectRatio: horizontal },
  { aspectRatio: horizontal },
  { aspectRatio: horizontal },
  { aspectRatio: horizontal },
  { aspectRatio: horizontal },
  { aspectRatio: horizontal },
];

export const nppPhotosMetadata: PhotoMetadata[] = [
  { aspectRatio: horizontal },
  { aspectRatio: horizontal },
  { aspectRatio: horizontal },
];

export const ncsiPhotosMetadata: PhotoMetadata[] = [
  { aspectRatio: horizontal },
  { aspectRatio: horizontal },
  { aspectRatio: horizontal },
  { aspectRatio: horizontal },
  { aspectRatio: horizontal },
];

export const hiddenflowsPhotosMetadata: PhotoMetadata[] = [
  { aspectRatio: horizontal },
  { aspectRatio: horizontal },
  { aspectRatio: horizontal },
  { aspectRatio: horizontal },
  { aspectRatio: horizontal },
  { aspectRatio: horizontal },
];

export const gfhPhotosMetadata: PhotoMetadata[] = [
  { aspectRatio: horizontal },
  { aspectRatio: horizontal },
];

export const afmacbmwPhotosMetadata: PhotoMetadata[] = [
  { aspectRatio: horizontal },
  { aspectRatio: horizontal },
   { aspectRatio: horizontal },
  { aspectRatio: horizontal },
  { aspectRatio: horizontal },
  { aspectRatio: horizontal },
];

export const kinfolkPhotosMetadata: PhotoMetadata[] = [
  { aspectRatio: horizontal },
  { aspectRatio: horizontal },
];

export const padalagosPhotosMetadata: PhotoMetadata[] = [
  { aspectRatio: horizontal },
  { aspectRatio: horizontal },
  { aspectRatio: horizontal },
  { aspectRatio: horizontal },
  { aspectRatio: horizontal },
  { aspectRatio: horizontal },
  { aspectRatio: horizontal },
  { aspectRatio: horizontal },
  { aspectRatio: horizontal },
  { aspectRatio: horizontal },
  { aspectRatio: horizontal },
  { aspectRatio: horizontal },
];

export const homePhotosMetadata: PhotoMetadata[] = [
  { aspectRatio: horizontal },
  { aspectRatio: horizontal },
  { aspectRatio: horizontal },
  { aspectRatio: horizontal },
  { aspectRatio: horizontal },
  { aspectRatio: horizontal },
  { aspectRatio: horizontal },
  { aspectRatio: horizontal },
  { aspectRatio: horizontal },
  { aspectRatio: horizontal },
  { aspectRatio: horizontal },
  { aspectRatio: horizontal },
];

export const tearSheetPhotosMetadata: PhotoMetadata[] = [
  { aspectRatio: vertical, description: "Sept 9, 2025, Kinfolk Magazine" },

  { aspectRatio: vertical, description: "March 20, 2025, NPR" },
  { aspectRatio: vertical, description: "Nov 15, 2024, The Guardian" },
  { aspectRatio: horizontal, description: "July 15, 2024, Les Echos" },
  { aspectRatio: horizontal, description: "Sept 17, 2024, Al Jazeera" },
  {
    aspectRatio: vertical,
    description: "June 21, 2024, Prince Claus Fund - 2023 Annual Report",
  },
  { aspectRatio: vertical, description: "Feb 2024, The Architectural Review" },
  { aspectRatio: vertical, description: "Oct 26, 2021, Financial Times" },
];
